import clone from 'lodash/clone';
import findKey from 'lodash/findKey';
import mapKeys from 'lodash/mapKeys';
import setWith from 'lodash/setWith';

import {
  SET_TOTAL_RESULTS,
  LOADING_RESULTS,
  LOADING_MORE_RESULTS,
  ADD_RESULT_CARDS,
  PRELOADING_DETAIL,
  CLEAR_PRELOADING_DETAIL,
  SET_RESULT_CARDS,
  SET_SCROLL_POSITION,
  SET_PAGE_INFO,
  RESET_LOADING_RESULTS,
} from '../constants';

const INITIAL_STATE = {
  totalResults: 0,
  loadingResults: false,
  loadingMoreResults: false,
  cards: {},
  scrollPosition: 0,
  currentPage: 0,
  totalPages: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_TOTAL_RESULTS: {
      return {
        ...state,
        totalResults: payload,
      };
    }
    case LOADING_RESULTS: {
      return {
        ...state,
        loadingResults: true,
      };
    }
    case LOADING_MORE_RESULTS: {
      return {
        ...state,
        loadingResults: true,
        loadingMoreResults: true,
      };
    }
    case ADD_RESULT_CARDS: {
      return {
        ...state,
        loadingResults: false,
        loadingMoreResults: false,
        cards: { ...state.cards, ...mapKeys(payload, 'listingId') },
      };
    }
    case SET_RESULT_CARDS: {
      return {
        ...state,
        loadingResults: false,
        loadingMoreResults: false,
        cards: mapKeys(payload, 'listingId'),
        scrollPosition: 0,
      };
    }
    // Payload: { currentPage, totalPages }
    case SET_PAGE_INFO: {
      return {
        ...state,
        currentPage: payload.currentPage,
        totalPages: payload.totalPages,
      };
    }
    // Payload: { id: '123' }
    // Cards are keyed by listingId, but the payload carries the (name-based) id, so
    // locate the card by its id field; fall back to using the payload as the key directly.
    case PRELOADING_DETAIL: {
      const key = findKey(state.cards, (c) => c.id === payload.id) || payload.id;
      const newState = setWith(clone(state), `cards["${key}"].preloading`, true, clone);
      return { ...state, ...newState };
    }
    // Payload: { id: '123' }
    case CLEAR_PRELOADING_DETAIL: {
      const key = findKey(state.cards, (c) => c.id === payload.id) || payload.id;
      const newState = setWith(clone(state), `cards["${key}"].preloading`, null, clone);
      return { ...state, ...newState };
    }
    case SET_SCROLL_POSITION: {
      return {
        ...state,
        scrollPosition: payload,
      };
    }
    case RESET_LOADING_RESULTS: {
      return {
        ...state,
        loadingResults: false,
        loadingMoreResults: false,
      };
    }
    default:
      return state;
  }
};
